import { render, staticRenderFns } from "./BlogpostSingle.vue?vue&type=template&id=d5e653d4&"
import script from "./BlogpostSingle.vue?vue&type=script&lang=js&"
export * from "./BlogpostSingle.vue?vue&type=script&lang=js&"
import style0 from "./BlogpostSingle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BlogpostSingle.vue"
export default component.exports